<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="认证用户" name="user_name"></c-form-item>
                    <c-form-item type="input" label="真实姓名" name="user_realname"></c-form-item>
                    <c-form-item type="input" label="证件号码" name="idcardno"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="state"></c-form-item>
                    <c-form-item type="datetime" label="认证时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>

            <c-table ref="table">
                <c-table-column
                    label="状态"
                    name="state"
                    width="60"
                >
                  <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                  <template v-slot="{data}">
                    <span v-if="data.state == 0" style="color:blue">待审核</span>
                    <span v-if="data.state == 1" style="color:green">审核通过</span>
                    <span v-if="data.state == 2" style="color:red">审核驳回</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="认证用户"
                        name="user_manage_mobilephone"
                        width="120"
                >
                  <template v-slot="{data}">
                    {{data.user_manage_mobilephone}}
                    <span v-if="data.nick_name && data.nick_name!=''">({{data.nick_name}})</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="真实姓名"
                    name="user_realname"
                    width="90"
                ></c-table-column>

                <c-table-column
                    label="证件号码"
                    name="idcardno"
                    width="120"
                ></c-table-column>

                <c-table-column
                  label="证件照片"
                  name="idcard_img"
                  width="120"
                >
                  <template v-slot="{data}">
                    <div  class="flex-center-cross">
                      <c-image v-for="(medias, j) in data.idcard_img_arr" :key="j" class="img" :src="oss(medias, 50, 50)" size="50" preview></c-image>
                    </div>
                  </template>
                </c-table-column>

                <c-table-column
                        label="认证时间"
                        name="update_date"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="审核人"
                        name="approval_user_realname"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="审核时间"
                        name="approval_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="100"
                >
                    <template v-slot="row">
                        <c-table-button @click="navigateTo(`/user_auth_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.state == 0" @click="navigateTo(`/user_auth_verify/${row.data.id}`)">审核</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'm_user_auth',

        props: {
            apply_state: String
        },

        data() {
            return {
                state: [{
                    name: '待审核',
                    value: 0
                }, {
                    name: '审核通过',
                    value: 1
                }, {
                    name: '审核驳回',
                    value: 2
                }]
            }
        },

        computed: {

            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            },

            defaultSearch() {
                let param = {
                    state: this.apply_state ? this.apply_state.split(',') : [],
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('userAuthList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/platform_user/auth/list',
                    data
                });
            }
        }
    }
</script>